import {
  chain,
  HStack,
  Link,
  PropertyWidget,
  Tag,
  VStack,
} from '@revolut-internal/ui-kit'
import { FC } from 'react'

import { Markdown } from 'components'
import { PtolemySearchAction } from 'lib/apiClient'
import { BACKOFFICE_URL, CONFLUENCE_URL } from 'lib/auth'

import { PtolemySearchSource } from './consts'

type Props = {
  data: PtolemySearchAction['clientOutput']['data']
}

export const PtolemySearchLinks: FC<Props> = props => {
  const { data } = props

  if (!data.length) {
    return null
  }

  return (
    <VStack space="s-8">
      {data.map(({ content, score, externalReference }) => {
        const source = externalReference?.source
        const value = externalReference?.value

        if (!source || !value || !content) {
          return null
        }

        let href: string | undefined

        switch (source) {
          case PtolemySearchSource.Ptolemy:
            href = `${BACKOFFICE_URL}/help/editor/external/${value}`
            break

          case PtolemySearchSource.Confluence:
            href = `${CONFLUENCE_URL}/wiki/pages/viewpage.action?pageId=${value}`
            break
        }

        if (!href) {
          return null
        }

        return (
          <PropertyWidget key={content}>
            <PropertyWidget.Details>
              <HStack space="s-8">
                <Tag variant="outlined" color="foreground">
                  {chain('Source', source)}
                </Tag>
                <Tag variant="outlined" color="foreground">
                  {chain('Score', score)}
                </Tag>
              </HStack>
            </PropertyWidget.Details>
            <PropertyWidget.Title>
              <Link href={href} target="_blank">
                {href}
              </Link>
            </PropertyWidget.Title>
            <PropertyWidget.Description>
              <Markdown>{content}</Markdown>
            </PropertyWidget.Description>
          </PropertyWidget>
        )
      })}
    </VStack>
  )
}
